import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

interface CenterManagerRouteProps {
  children: React.ReactNode
}

const CenterManagerRoute: React.FC<CenterManagerRouteProps> = ({ children }) => {
  const { session, loading, role } = useAuth()
  const navigate = useNavigate()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-900">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (!session?.user) {
    navigate('/auth')
    return null
  }

  if (role !== 'center_manager' && role !== 'super_admin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-900">
        <div className="text-center">
          <div className="text-red-600 dark:text-red-400 text-lg font-semibold mb-2">
            Access Denied
          </div>
          <div className="text-neutral-600 dark:text-neutral-300">
            Center manager or super admin access required
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default CenterManagerRoute








